<template>
  <div>
    <div :class="['d-flex geocoder-address', {'active': geocoderAddress}]">
      <strong v-if="hasGeocoderAddress && !selected">{{ $t('MapLocationControls.addressSuggestion') }}</strong>
      <div class="mt-1">
        {{ geocoderAddress }}
      </div>
      <div v-if="hasGeocoderAddress && !selected">
        <Button
          type="button"
          icon="pi pi-ban"
          class="align-self-center p-button-sm grey mr-2"
          @click="handleCancelDisconnect"
        />
        <Button
          v-if="!noAddressFound"
          type="button"
          :label="$t('MapLocationControls.button.takeOver')"
          class="align-self-center p-button-sm p-button-success"
          @click="$emit('useGeocoderAddress')"
        />
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <Button
        v-if="isPinnedLocation"
        type="button"
        :label="$t('Information.lastPinnedLocation')"
        class="align-self-end p-button-sm grey"
        @click="$emit('resetLocation')"
      />
      <Button
        v-if="!isAssetProcess && locationEditEnabled && selected && !geocoderAddress"
        v-tooltip.top="{ value: $t('processes.map.disconnect_location')}"
        type="button"
        class="align-self-end p-button-sm grey"
        @click="handleDisconnectLocation"
      >
        <i
          class="fa-light fa-location-dot-slash"
          style="font-size:1.5em;"
        />
      </Button>
      <Button
        v-if="canCancel && !alternative || (!connectionEnabled && savedChargingpointUuid)"
        v-tooltip.top="{ value: $t('processes.map.cancelDisconnectLocation')}"
        type="button"
        class="align-self-end p-button-sm grey"
        @click="handleCancelDisconnect"
      >
        <i
          class="fa-light fa-ban"
          style="font-size:1.5em;"
        />
      </Button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Button from 'primevue/button'
import Tooltip from 'primevue/tooltip'
export default {
  name: 'MapLocationControls',
  components: { Button },
  directives: {
    'tooltip': Tooltip,
  },
  props: {
    hasPinnedAddress: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isPinnedLocation: {
      type: Boolean,
      default: false,
    },
    municipalityCode: {
      type: String,
      default: '',
    },
    alternative: {
      type: Boolean,
      default: false,
    },
    geocoderAddress: {
      type: String,
      default: '',
    },
    selected: {
      type: String,
      default: null,
    },
    locationEditEnabled: {
      type: Boolean,
      default: false,
    },
    isAssetProcess: {
      type: Boolean,
      default: false
    },
    isNewProcess: {
      type: Boolean,
      default: false
    },
    connectionEnabled: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters('realisation', ['getSavedRecordValues']),
    ...mapGetters('processes', ['getSelectedProcess']),

    isSavedRealisation () {
      return !!(this.getSelectedProcess?.ref || this.$route.params?.step) // && !this.alternative
    },
    noAddressFound () {
      return /pin|point/i.test(this.geocoderAddress)
    },
    hasGeocoderAddress () {
      if (this.isNewProcess && this.noAddressFound) return true;

      return this.geocoderAddress && !this.noAddressFound
    },
    isAmsterdam () {
      return process.env.VUE_APP_TENANT === 'amsterdam'
    },
    savedChargingpointUuid () {
      return this.getSavedRecordValues?.Location?.chargingpointUuid || this.getSelectedProcess?.location?.chargingStation?.chargingpointUuid
    },
    canCancel () {
      if (!this.isSavedRealisation) {
        return false
      }

      if (!this.connectionEnabled) return true;

      return this.isSavedRealisation && !!this.geocoderAddress &&
             ((this.hasGeocoderAddress && !this.selected) ||
             (!this.selected && !this.hasGeocoderAddress) ||
             /pin|point/i.test(this.geocoderAddress) ||
             (!this.alternative && (!this.selected || this.selected !== this.savedChargingpointUuid) &&
             !this.isPinnedLocation && !this.hasPinnedAddress)) // Location disconnected but not yet saved
    },
  },
  methods: {
    handleDisconnectLocation () {
      this.$emit('disconnectLocation', { uuid: null })
    },
    handleCancelDisconnect () {
      this.$emit('cancelLocationChange')
    }
  }
}
</script>
<style lang="scss" scoped>
.p-button.grey {
  &:hover, &:enabled:hover, &:enabled:active {
    border-color: #6c757d;
    background: #666;
    box-shadow: none;
  }
  &.p-button-sm {
    background: #6c757d;
    border-color: #6c757d;
  }
}
.geocoder-address {
  position: absolute;
  margin-top: 0;
  background: white;
  padding: 1em;
  width: calc(100% - 2em);
  left: 1em;
  flex-flow: row wrap;
  justify-content: space-between;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  z-index: -1;
  flex-flow: row wrap;
  opacity: 0;
  transition: opacity 0.4s ease-out, margin-top 0.2s ease-in-out;
  strong {
    flex: 0 0 100%;
  }
  &.active {
    opacity: 1;
    margin-top: -8em;
    z-index: 3;
  }
}
</style>
